module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/profile/profile-f2-618c22b3e2aba61a757fe813a094941d.png";